import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'
//import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                accent: "#FF9800",
                warning: "#BF360C", //added to override default warning color to cater accessibility fix
            },
            dark: {
                accent: "#FF9800",
            }
        },
        options: {
            customProperties: true,
            variations: false,
            cspNonce: 'dQw4w9WgXcQ',
        }
    }
})
